export default "__VITE_ASSET__7574dab3__"